import React, { useState } from 'react';
import cx from 'classnames';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { ReactComponent as Success } from 'app/components/svg/Success.svg';
import { ReactComponent as LinkSvg } from 'app/components/svg/Link.svg';
import Button from 'app/components/ui/Button';

import s from './Link.module.sass';

type LinkProps = {
  className?: string
  value: string;
  theme?: 'plain'
};

const Link: React.FC<LinkProps> = ({ className, value, theme }) => {
  const [success, setSuccess] = useState<boolean>(false);

  const handleSetSuccessOfCopy = () => {
    if (!success) {
      setSuccess(true);

      setTimeout(() => setSuccess(false), 2000);
    }
  };

  const compoundClassName = cx(
    s.root,
    { [s.success]: success },
  );

  return (
    <CopyToClipboard
      text={value}
      onCopy={handleSetSuccessOfCopy}
    >
      <Button
        sizeT="small"
        theme={theme || 'clear'}
        className={className}
      >
        <div
          className={compoundClassName}
        >
          <Success className={cx(s.arrow)} />
          <LinkSvg className={cx(s.clipboard)} />
        </div>
      </Button>
    </CopyToClipboard>
  );
};
export default Link;
